<template>
  <div class="alert-stack" aria-live="polite" aria-label="Fleet alerts">
    <AlertToast
      v-for="alert in alerts"
      :key="alert.id"
      :alert="alert"
      :duration="30000"
      @dismissed="remove"
      @view-detail="onViewDetail"
    />
  </div>
</template>

<script> 
import { alertBus } from '@/plugins/alertBus'
// import Vue from 'vue'
import AlertToast from './AlertToast.vue'
// export const alertBus = new Vue() 
import { mapActions } from "vuex";

export default {
  name: 'AlertStack',
  components: { AlertToast }, 
  mounted() {
    console.log( alertBus);  
    alertBus.$on('push-alert', this.push)
  },
  beforeDestroy() {
    alertBus.$off('push-alert', this.push)  // always clean up or you leak listeners
  }, 
  data() {
    return {
      alerts: [],
      maxVisible: 5,
    }
  },
  methods: {
    ...mapActions([ 
      "mark_event_read"
    ]),

    push(alert) {
      const newAlert = {
        id: Date.now() + Math.random(),
        ...alert,
        timestamp: alert.timestamp || new Date().toISOString(),
      }

      // Cap stack — silently drop oldest if over limit
      if (this.alerts.length >= this.maxVisible) {
        this.alerts.shift()
      }

      this.alerts.push(newAlert)
    },

    remove(id) {
      const idx = this.alerts.findIndex(a => a.id === id)
      if (idx !== -1) this.alerts.splice(idx, 1)
    },

    onViewDetail(alert) {
      // Push to router — adjust route name to match yours
      this.$store.dispatch("mark_event_read",alert.eventId); 
      this.$router.push({
        name: 'EventDetail',
        params: { id: alert.eventId },
        query:  { id: alert.eventId  },
      })
    },
  },
}
</script>

<style scoped>
.alert-stack {
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  flex-direction: column-reverse;
  gap: 10px;
  z-index: 99999999;
  pointer-events: none; /* stack itself is click-through */
}
</style>